import { useEffect, useState } from "react";
import { closeModal, Modal, openModal, TextInput } from "risa-oasis-ui_v2";
import CustomCheckBox from "../../../../../components/customCheckBox/customCheckBox";
import { ProviderOption } from "../../../../../data-model/providerOptionModel";
import { ModalId } from "../../../../../enums/modalId";

interface ProviderOptionFormModalProps {
  option: ProviderOption | null;
  isAddMode: boolean;
  onSave: (data: Omit<ProviderOption, "id">) => Promise<void>;
  onClose: () => void;
  isSaving?: boolean;
}

const ProviderOptionFormModal: React.FC<ProviderOptionFormModalProps> = ({
  option,
  isAddMode,
  onSave,
  onClose,
  isSaving = false,
}) => {
  const [name, setName] = useState("");
  const [uid, setUid] = useState("");
  const [showOnList, setShowOnList] = useState(true);
  const isOpen = isAddMode || !!option;
  const isEditMode = !!option;

  useEffect(() => {
    if (isOpen) {
      openModal(ModalId.PROVIDER_OPTION_FORM_MODAL);
    }
  }, [isOpen]);

  useEffect(() => {
    if (isEditMode && option) {
      setName(option.name);
      setUid(option.uid);
      setShowOnList(option.show_on_list);
    } else {
      setName("");
      setUid("");
      setShowOnList(true);
    }
  }, [isEditMode, option]);

  const handleClose = () => {
    closeModal(ModalId.PROVIDER_OPTION_FORM_MODAL);
    onClose();
  };

  const handleSave = async () => {
    if (!name.trim() || !uid.trim()) return;
    await onSave({
      name: name.trim(),
      uid: uid.trim(),
      show_on_list: showOnList,
    });
    closeModal(ModalId.PROVIDER_OPTION_FORM_MODAL);
    onClose();
  };

  const canSave = name.trim().length > 0 && uid.trim().length > 0;

  if (!isOpen) return null;

  return (
    <Modal
      dialogId={ModalId.PROVIDER_OPTION_FORM_MODAL}
      title={isEditMode ? "Edit Provider Option" : "Add Provider Option"}
      onSave={handleSave}
      onCancel={handleClose}
      onClose={handleClose}
      saveButtonText={isSaving ? "Saving..." : "Save"}
      cancelText="Cancel"
      disableSave={!canSave || isSaving}
      autoCloseOnSave={false}
    >
      <div className="flex flex-col gap-4">
        <TextInput
          id="provider-name"
          label="Name"
          placeholder="Enter provider name"
          defaultValue={isEditMode ? option?.name : ""}
          resetField={!isOpen}
          onChange={(data: any) => setName(data.value)}
          onBlur={(data: any) => setName(data.value)}
          required
        />
        <TextInput
          id="provider-uid"
          label="UID"
          placeholder="Enter provider UID"
          defaultValue={isEditMode ? option?.uid : ""}
          resetField={!isOpen}
          onChange={(data: any) => setUid(data.value)}
          onBlur={(data: any) => setUid(data.value)}
          readOnly={isEditMode}
          required
        />
        <CustomCheckBox
          id="show-on-list"
          label="Show on List"
          isChecked={showOnList}
          onCheckBoxValueChange={(data) => setShowOnList(data.value)}
        />
      </div>
    </Modal>
  );
};

export default ProviderOptionFormModal;
